import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DraggablePopup from '../../DraggablePopup';
import { Container, StickyFooter } from '../../../styled-components/Layout';
import FolderTree from '../FolderTree/FolderTree';
import Colors from '../../../constants/colors';
import { Button, Input } from '../../../styled-components';
import SavedItemsExpiration from '../../../constants/savedItemsExpiration';
import localize from '../../../util/localizeUtils';
import { getSpecialFolder } from '../../../util/savedItemsUtils';

const DialogContainer = styled(Container)`
  background: ${Colors.DIALOG_BACKGROUND};
  padding: 0.5rem;
`;

const FolderTreeContainer = styled.div`
  border: 1px solid #b7b7b7;
  background: white;
  flex: 1;
  overflow: auto;
`;

const Info = styled.div`
  display: flex;
  align-items: center;
`;

const Checkbox = styled(Input)`
  margin-right: 0.25rem;
`;

const ButtonContainer = styled(Container)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 0.5rem;
  height: 2rem;
`;
const InfoContainer = styled(Container)`
  margin-top: 0.25rem;
  display: flex;
  flex-direction: column;
  height: auto;
`;

const Bold = styled.span`
  font-weight: bold;
`;

const DialogButton = styled(Button)`
  margin-left: 0.5rem;
`;

class SavedItemsDialog extends PureComponent {
  constructor() {
    super();

    this.state = {
      preserveMosId: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.isOpen !== nextProps.isOpen) {
      this.setState({ preserveMosId: false });
    }
  }

  getSelectedFolderUser = () => {
    const { selectedFolder, userId } = this.props;

    if (!selectedFolder || (selectedFolder && !selectedFolder.id)) return '';

    if (selectedFolder.owner === userId) {
      return localize('folderVisibilityYouText');
    } else if (selectedFolder.owner && selectedFolder.owner !== userId) {
      return localize('folderVisibilityOtherText');
    }
    return localize('folderVisibilityAllText');
  };

  getSelectedFolderExpiration = () => {
    const { selectedFolder } = this.props;

    if (!selectedFolder || (selectedFolder && !selectedFolder.id)) return '';

    switch (selectedFolder.expirationHours) {
      case SavedItemsExpiration.WEEK:
        return localize('savedItemExpirationWeekText');
      case SavedItemsExpiration.DAY:
        return localize('savedItemExpirationDayText');
      default:
        return localize('savedItemExpirationManualText');
    }
  };

  getPixelHeight = () => Math.min(window.innerHeight * 0.75, 400);

  getPixelWidth = () => Math.min(window.innerWidth * 0.75, 600);

  render() {
    const isValidFolderSelected = this.props.selectedFolder && this.props.selectedFolder.id;
    return (
      <DraggablePopup
        visible={this.props.isOpen}
        title={localize('saveItemTitle')}
        handle=".handle"
        height={this.getPixelHeight()}
        width={this.getPixelWidth()}
        closeDialog={this.props.closeDialog}
      >
        <DialogContainer>
          <FolderTreeContainer>
            <FolderTree pullFolders />
          </FolderTreeContainer>
          <StickyFooter>
            <InfoContainer>
              <Info>
                {localize('folderVisibilityLabel')}<Bold> {this.getSelectedFolderUser()}</Bold>
              </Info>
              <Info>
                {localize('savedItemExpirationLabel')}<Bold> {this.getSelectedFolderExpiration()}</Bold>
              </Info>
              {this.props.showSaveAs && this.props.mosObjectId && (
                <Info>
                  <Checkbox
                    type="checkbox"
                    onClick={() => this.setState({ preserveMosId: !this.state.preserveMosId })}
                    value={this.state.preserveMosId}
                  />
                  {localize('saveAsLabel')} &nbsp;<Bold>{this.props.mosObjectId}</Bold>
                </Info>
              )}
            </InfoContainer>
            <ButtonContainer>
              <DialogButton
                onClick={() => this.props.onSubmit(this.state.preserveMosId)}
                disabled={!isValidFolderSelected}
              >
                {localize('saveButton')}
              </DialogButton>
              <DialogButton onClick={this.props.closeDialog}>{localize('cancelButton')}</DialogButton>
            </ButtonContainer>
          </StickyFooter>
        </DialogContainer>
      </DraggablePopup>
    );
  }
}

SavedItemsDialog.defaultProps = {
  isOpen: false,
  selectedFolder: null,
  mosObjectId: null,
  showSaveAs: false
};

SavedItemsDialog.propTypes = {
  isOpen: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  selectedFolder: PropTypes.object,
  mosObjectId: PropTypes.string,
  userId: PropTypes.number.isRequired,
  showSaveAs: PropTypes.bool
};

const mapStateToProps = state => {
  const selectedFolder = state.savedItems.selectedFolder;
  let folder = null;

  if (selectedFolder && selectedFolder < 0) {
    folder = getSpecialFolder(selectedFolder);
  } else if (selectedFolder) {
    folder = state.savedItems.folders[selectedFolder];
  }

  return {
    selectedFolder: folder,
    userId: state.auth.user.userId
  };
};

export default connect(mapStateToProps)(SavedItemsDialog);



// WEBPACK FOOTER //
// ./app/components/SavedItems/Dialog/index.js